import React, {useRef, useState, useEffect} from 'react'
import styled from "styled-components";
import RadiusGenerate from "@helpers/radius.generate";
import DropdownHeader from "./dropdwon.header";
import DropdownInput from './dropdown.inputs';
import DropdownFooter from "./dropdown.footer";
import dynamic from "next/dynamic";
import DropdownSelectedItems from "./dropdown.selected.items";
import {is_array} from "@helpers/arrays";
import {isEmpty} from "@helpers/helpers";

const Lists = dynamic(() => import('./lists'), {
    ssr: false
});

function Dropdown({type, name, label, items, show, setShow, searchable, handleItems, handleSearch, selected_range, selected_items, limit_select, select_optional, itemsPosition, setItemsPosition, dropdownRef, icon, showSelectedItemsInTop, perfectScrollbar}) {
    let footer = true;
    if (type === 'single' && !select_optional) {
        footer = false;
    }

    const Ref = useRef(null);
    const [topItems, setTopItems] = useState([]);
    const [itemsPaginate, setItemsPaginate] = useState({page: 1});

    useEffect(() => {
        const dropdownListsMobile = dropdownRef.current.querySelector('.selection-lists');

        if (!isEmpty(dropdownListsMobile)) {
            dropdownListsMobile.addEventListener('scroll', handleItemsScroll, false);
            return () => dropdownListsMobile.removeEventListener('scroll', handleItemsScroll)
        }
    });

    useEffect(() => {
        //console.log(selected_items)
        if (isEmpty(selected_items) || (is_array(selected_items) && !selected_items.length)) {
            setTopItems([])
        }

        if (showSelectedItemsInTop && process.browser && window.innerWidth < 768) {
            let selectedItems = [];

            for (let item of items) {
                if ((isEmpty(limit_select) || selectedItems.length <= limit_select) && item.checked) {
                    // selectedItems = prepend_array(item, selectedItems);
                    selectedItems.push(item)
                }
            }

            setTopItems(selectedItems)
        }
    }, [show, selected_items]);


    const handleDropdownClick = (event) => {
        if (process.browser && window.innerWidth < 992) {
            if (show && Ref.current && !Ref.current.contains(event.target)) {
                setShow(false)
            }
        }
    };


    const handleItemsScroll = (e, is_target = false) => {
        let target = e;
        if (!is_target) {
            target = e.target;
        }

        const offsetHeight = target.offsetHeight;
        const scrollTop = target.scrollTop;
        const scrollHeight = target.scrollHeight;

        if (offsetHeight + scrollTop + 1 >= scrollHeight) {
            setItemsPaginate({page: itemsPaginate.page + 1})
        }
    };

    return (
        <Container ref={dropdownRef} onClick={handleDropdownClick} className={"selection-dropdown-container " + type}>
            <Wrapper className="selection-dropdown-wrapper d-flex flex-column" show={show} ref={Ref}>
                <DropdownHeader
                    label={label}
                    setShow={setShow}
                />

                <DropdownInput
                    type={type}
                    searchable={searchable}
                    handleSearch={handleSearch}
                    selected_range={selected_range}
                    setItemsPosition={setItemsPosition}
                    handleItems={handleItems}
                />

                {
                    (showSelectedItemsInTop && topItems.length > 0 && process.browser && window.innerWidth < 768) ?
                        <DropdownSelectedItems
                            topItems={topItems}
                            setTopItems={setTopItems}
                            handleItems={handleItems}
                        />
                        : ''
                }

                <Lists
                    items={items.slice(0, itemsPaginate.page * 20)}
                    type={type}
                    name={name}
                    handleItems={handleItems}
                    searchable={searchable}
                    footer={footer}
                    itemsPosition={itemsPosition}
                    select_optional={select_optional}
                    icon={icon}
                    showSelectedItemsInTop={showSelectedItemsInTop}
                    topItems={topItems}
                    setTopItems={setTopItems}
                    limit_select={limit_select}
                    perfectScrollbar={perfectScrollbar}
                    handleItemsScroll={handleItemsScroll}
                />

                <DropdownFooter
                    setShow={setShow}
                    footer={footer}
                />
            </Wrapper>
        </Container>
    )
}

export default React.memo(Dropdown);

// styles
const Wrapper = styled.div`
    background-color: ${props => props.theme.white};
    height: 100%;
    border-radius: 16px;
    
    @media only screen and (min-width: ${props => props.theme.screenSmMin}) and (max-width: ${props => props.theme.screenSmMax}) {
        max-width: 420px;
        position: relative;
        border-radius: 16px;
        width: 100%;
        height: 100%;
        display: ${props => props.show ? 'block' : 'none'};
        background-color: #FFFFFF;
    }
`;

export const Container = styled.div`
    position: absolute;
    top: 43px;
    right: 0;
    z-index: 5012;
    display: none;
    background-color: ${props => props.theme.white};
    padding: 24px 0;
    min-width: 256px;
    box-shadow: 0 10px 37px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px ${props => props.theme.gray200};
    ${RadiusGenerate('16px')};
    
    &.show-dropdown {
        display: block;
    }
    
    &.range {
        min-width: 300px;
    }
    
    @media only screen and (max-width: ${props => props.theme.screenSmMax}) {
        position: fixed;
        display: none;
        flex-direction: column;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
        padding: 0;
        overflow: hidden;
        border-radius: 0;
        z-index: 5010;
        
        &.show-dropdown {
            display: flex;
        }
    }
    
    @media only screen and (min-width: ${props => props.theme.screenSmMin}) and (max-width: ${props => props.theme.screenSmMax}) {
        display: none;
        align-items: flex-end;
        justify-content: center;
        flex-direction: inherit;
        padding: 48px !important;
        background-color: rgba(0, 0, 0, 0.5);
        
        &.show-dropdown {
            display: flex;
        }
    }
    
    &.multiple,&.range {
        padding-bottom: 0;
    }
`;